// removed by extract-text-webpack-plugin
module.exports = {"link":"TermsOfUseLink__link___3zO49"};